import React, { memo, useCallback } from 'react';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazy } from '@atlassian/react-loosely-lazy';
import type {
	ProjectTemplatesDataType,
	OpenDrawerMethod,
} from '../../../../services/project-templates/types.tsx';
import OneClickProjectButton from './main.tsx';
import type TemplatePickerType from './template-picker/index.tsx';
import { TemplatePickerFallback } from './template-picker/index.tsx';
// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
export const LazyTemplatePicker = lazy<typeof TemplatePickerType>(
	() => import(/* webpackChunkName: "async-sidebar-template-picker" */ './template-picker'),
	{ ssr: false },
);

type Props = {
	openProjectCreateDrawer: OpenDrawerMethod;
};

const OneClickProject = ({ openProjectCreateDrawer }: Props) => {
	const renderContent = useCallback(
		(data: ProjectTemplatesDataType, loading: boolean) => (
			<Placeholder name="sidebar-template-picker" fallback={<TemplatePickerFallback />}>
				<LazyTemplatePicker
					data={data}
					loading={loading}
					openProjectCreateDrawer={openProjectCreateDrawer}
				/>
			</Placeholder>
		),
		[openProjectCreateDrawer],
	);

	return (
		<OneClickProjectButton
			renderContent={renderContent}
			openProjectCreateDrawer={openProjectCreateDrawer}
		/>
	);
};

export default memo<Props>(OneClickProject);
